import React, { useEffect } from "react";
import Footer from "../../components/Footer";
import ScrollToTop from "../../components/ScrollToTop";
import HomePagePanel from "../../components/HomePagePanel";
import HomePageImage from "../../components/HomePageImage";
import DichVuBanner from "../../components/Banner/DichVuBanner";
import ServiceProcess from "../../components/ServiceProcess";
import "../../css/Service.css";

export default function Service() {
    useEffect(() => {
        document.title = "MinMin Wedding - Phóng Sự Cưới | Service";
    }, []);

    return (
        <>
            <ScrollToTop />

            <DichVuBanner />

            {/* <HomePageImage /> */}

            <HomePagePanel />

            {/* <ServiceProcess /> */}

            <Footer />
        </>
    );
}